module.exports = __webpack_public_path__ + "img/MotorWithVFD.aadb7bbb.png";